import { useState } from "react";

// Temporary photo review page — shows every downloaded property photo
// so you can pick the ones for each section of the cinematic redesign.
const PHOTOS = [
  "DSC00004", "DSC00010", "DSC00019", "DSC00022", "DSC00030",
  "DSC00037", "DSC00038", "DSC00042", "DSC00044", "DSC00056",
  "DSC00068", "DSC00084", "DSC00088", "DSC00089", "DSC00091",
  "DSC00106", "DSC00110", "DSC00113", "DSC00118", "DSC00123",
  "DSC00129", "DSC00156", "DSC09965", "DSC09967", "DSC09976",
  "DSC09979", "DSC09981", "DSC09994", "DSC09998",
];

const PhotoReviewPage = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="min-h-screen bg-[#0A1628] text-white p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C9A962] mb-2">Photo Review</p>
          <h1 className="font-display text-3xl mb-2">All 29 property photos</h1>
          <p className="text-sm text-white/60">
            Click any photo to enlarge. Note the file names of the ones you want featured in the
            hero carousel, gallery, and section backgrounds.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
          {PHOTOS.map((name) => (
            <button
              key={name}
              onClick={() => setSelected(name)}
              className="group relative aspect-[4/3] overflow-hidden bg-black"
            >
              <img
                src={`/photos/${name}.webp`}
                alt={name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 bg-black/70 px-3 py-2 text-xs font-mono">
                {name}
              </div>
            </button>
          ))}
        </div>

        {selected && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-6 cursor-zoom-out"
            onClick={() => setSelected(null)}
          >
            <div className="relative max-w-6xl max-h-full">
              <img
                src={`/photos/${selected}.webp`}
                alt={selected}
                className="max-w-full max-h-[85vh] object-contain"
              />
              <div className="absolute -bottom-10 left-0 right-0 text-center text-[#C9A962] font-mono text-sm">
                {selected}.jpg — click anywhere to close
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoReviewPage;
